<template>
  <FormWrapper>
    <div v-if="user" id="debuggerOutput" class="debugger-output">
      <JsonView
        :value="{
          userinfo: user.profile,
          jwt_access_token: parseJwt(user.access_token),
          jwt_id_token: user.id_token ? parseJwt(user.id_token) : null,
        }"
      />
      <div class="margin-top-l">
        <JsonView :value="{ access_token: user.access_token }" copyable />
      </div>
    </div>

    <TnNotificationInline
      v-else-if="error"
      horizontal
      status="critical"
      title="Callback failed"
      class="margin-top-l"
    >
      {{ error }}
    </TnNotificationInline>
  </FormWrapper>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import type { User } from 'oidc-client-ts';
import { TnNotificationInline } from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from './FormWrapper.vue';
import JsonView from './JsonView.vue';
import { EnvironmentService } from '@/environment';
import { createUserManager, loadOptions, parseJwt } from '@/views/debugger/debugger.service';

const route = useRoute();

const user = ref<User | null>(null);
const error = ref<string | null>(null);

onMounted(async () => {
  if (!route.query.state || !route.query.code) {
    error.value = 'Missing state param/code in return url?!';
    console.error(error.value);
    return;
  }

  try {
    const environment = await EnvironmentService.getEnvironment();
    user.value = await createUserManager(environment.value, loadOptions()).signinRedirectCallback();
  } catch (err) {
    error.value = err instanceof Error ? err.message : String(err);
    console.error(err);
  }
});
</script>

<style scoped>
.debugger-output {
  width: 100%;
  max-width: 768px;
  margin-inline: auto;
  padding-inline: 16px;
}
</style>
